// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1aGZq","rootSmall":"AddTileButton_rootSmall__En6Rp"};